export type TradingAccountIdentity = { id: string };

export function shouldShowTradingAccountSelector(accounts: TradingAccountIdentity[], loading: boolean): boolean {
  return !loading && accounts.length > 1;
}

export function resolveSelectedTradingAccountId(
  accounts: TradingAccountIdentity[],
  currentAccountId: string,
  persistedAccountId?: string | null,
): string {
  if (accounts.length === 1) return accounts[0].id;
  if (accounts.length === 0) return '';
  if (persistedAccountId != null && accounts.some((account) => account.id === persistedAccountId)) return persistedAccountId;
  return accounts.some((account) => account.id === currentAccountId) ? currentAccountId : '';
}
